import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFilters, IGroup, IGroupsList } from 'v3/data/store/group/types';
import { groupsInitialState } from './state';

export const groupsSlice = createSlice({
  name: 'group',
  initialState: groupsInitialState,
  reducers: {
    setGroupName: (state, action: PayloadAction<IGroup>) => {
      state.group = action.payload;
      return state;
    },
    setGroupList: (state, action: PayloadAction<IGroupsList>) => {
      state.list = action.payload;
      return state;
    },
    setFilters: (state, action: PayloadAction<IFilters>) => {
      state.filter = action.payload;
      return state;
    },

    setFilterRowsPerPage: (state, action: PayloadAction<number>) => {
      state.filter.rowsPerPage = action.payload;
      return state;
    },
    setFilterCurrentPage: (state, action: PayloadAction<number>) => {
      state.filter.page = action.payload;
      return state;
    },
    setFilterGroupName: (state, action: PayloadAction<string>) => {
      state.filter.name = action.payload;
      return state;
    },
  },
});
